const undef = undefined
const VERSION_INSURANCE = '3.8.5'
const VERSION_INSURANCE_CASE_DETAIL = '4.0.0'
const REGEX1 = /\/(.*?)\(/i
const REGEX = /^.*[com.tentcoo.XiaoPengQiCheEnterprise|com.xiaopeng.XiaoPengQiChe|com.xiaopeng.mycarinfo]\/([\d|.]*)/

function compare(version1: string, version2: string, comparison = '===') {
  const version1Arr = version1.split('.').map(item => Number(item))
  const version2Arr = version2.split('.').map(item => Number(item))
  const length = Math.max(version1Arr.length, version2Arr.length)
  const arr: any = []
  let result = false

  for (let i = 0; i < length; i++) {
    const v1 = version1Arr[i] === undef ? 0 : version1Arr[i]
    const v2 = version2Arr[i] === undef ? 0 : version2Arr[i]

    if (v1 > v2) {
      arr[i] = 1
    } else if (v1 === v2) {
      arr[i] = 0
    } else {
      arr[i] = -1
    }
  }

  switch (comparison) {
    case '===':
      for (let i = 0; i < length; i++) {
        if (arr[i] === 0) {
          result = true
        } else {
          result = false
          break
        }
      }
      break
    case '>=':
      for (let i = 0; i < length; i++) {
        if (arr[i] > 0) {
          result = true
          break
        } else if (arr[i] === 0) {
          result = true
        } else {
          result = false
          break
        }
      }
      break
    case '>':
      for (let i = 0; i < length; i++) {
        if (arr[i] > 0) {
          result = true
          break
        } else if (arr[i] === 0) {
          result = false
        } else {
          result = false
          break
        }
      }

      break
    case '<=':
      for (let i = 0; i < length; i++) {
        if (arr[i] > 0) {
          result = false
          break
        } else if (arr[i] === 0) {
          result = true
        } else {
          result = true
          break
        }
      }
      break
    case '<':
      for (let i = 0; i < length; i++) {
        if (arr[i] > 0) {
          result = false
          break
        } else if (arr[i] === 0) {
          result = true
        } else {
          result = true
          break
        }
      }
      break
    default:
      break
  }

  return result
}

function exec(regex: RegExp, useragent: string) {
  return regex.exec(useragent)
}

export { VERSION_INSURANCE, VERSION_INSURANCE_CASE_DETAIL, REGEX1, REGEX, compare, exec }
